import React from "react";
import { useParams } from "react-router-dom";
import { usePublicSettings } from "@/lib/settings";

const TITLES = { privacy: "Privacy Policy", terms: "Terms & Conditions", refund: "Refund Policy" };

export default function Legal() {
  const { page } = useParams();
  const { settings } = usePublicSettings();
  const legal = settings?.legal || {};
  const title = TITLES[page] || "Policy";
  const body = legal[page] || "Content coming soon.";

  return (
    <div className="mx-auto max-w-3xl px-4 sm:px-6 py-12">
      <h1 className="font-display text-4xl sm:text-5xl uppercase text-white mb-6 leading-none">{title}</h1>
      <p className="text-zinc-300 leading-relaxed whitespace-pre-line">{body}</p>
    </div>
  );
}
